export const organizationsTags = {
  TREE: 'Tree',
  ORGANIZATIONS: 'Organizations',
  ORGANIZATION: 'Organization',
  ALL_ORGANIZATIONS: 'AllOrganizations',
  BASIC_ORGANIZATIONS: 'BasicOrganizations',
  PRIMARY_ORGANIZATIONS: 'PrimaryOrganizations',
  REGIONAL_ORGANIZATIONS: 'RegionalOrganizations',
  STRUCTURAL: 'Structural',
  SHORT: 'Short',
};
